/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TimezoneMetadata } from './TimezoneMetadata';
import {
    TimezoneMetadataFromJSON,
    TimezoneMetadataFromJSONTyped,
    TimezoneMetadataToJSON,
    TimezoneMetadataToJSONTyped,
} from './TimezoneMetadata';

/**
 * 
 * @export
 * @interface ContainerLayeredBackfillResponse
 */
export interface ContainerLayeredBackfillResponse {
    /**
     * 
     * @type {boolean}
     * @memberof ContainerLayeredBackfillResponse
     */
    success?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ContainerLayeredBackfillResponse
     */
    tenantId?: string;
    /**
     * 
     * @type {number}
     * @memberof ContainerLayeredBackfillResponse
     */
    processed?: number;
    /**
     * 
     * @type {number}
     * @memberof ContainerLayeredBackfillResponse
     */
    failed?: number;
    /**
     * 
     * @type {string}
     * @memberof ContainerLayeredBackfillResponse
     */
    userTimezone?: string;
    /**
     * Error message if the request failed
     * @type {string}
     * @memberof ContainerLayeredBackfillResponse
     */
    error?: string;
    /**
     * 
     * @type {TimezoneMetadata}
     * @memberof ContainerLayeredBackfillResponse
     */
    timezoneMetadata?: TimezoneMetadata;
}

/**
 * Check if a given object implements the ContainerLayeredBackfillResponse interface.
 */
export function instanceOfContainerLayeredBackfillResponse(value: object): value is ContainerLayeredBackfillResponse {
    return true;
}

export function ContainerLayeredBackfillResponseFromJSON(json: any): ContainerLayeredBackfillResponse {
    return ContainerLayeredBackfillResponseFromJSONTyped(json, false);
}

export function ContainerLayeredBackfillResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ContainerLayeredBackfillResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'success': json['success'] == null ? undefined : json['success'],
        'tenantId': json['tenantId'] == null ? undefined : json['tenantId'],
        'processed': json['processed'] == null ? undefined : json['processed'],
        'failed': json['failed'] == null ? undefined : json['failed'],
        'userTimezone': json['userTimezone'] == null ? undefined : json['userTimezone'],
        'error': json['error'] == null ? undefined : json['error'],
        'timezoneMetadata': json['timezone_metadata'] == null ? undefined : TimezoneMetadataFromJSON(json['timezone_metadata']),
    };
}

export function ContainerLayeredBackfillResponseToJSON(json: any): ContainerLayeredBackfillResponse {
    return ContainerLayeredBackfillResponseToJSONTyped(json, false);
}

export function ContainerLayeredBackfillResponseToJSONTyped(value?: ContainerLayeredBackfillResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'success': value['success'],
        'tenantId': value['tenantId'],
        'processed': value['processed'],
        'failed': value['failed'],
        'userTimezone': value['userTimezone'],
        'error': value['error'],
        'timezone_metadata': TimezoneMetadataToJSON(value['timezoneMetadata']),
    };
}

